<template>
  <div class="box-sizing" style="width: 100%;height: 100%;display: flex;align-items: center; justify-content: center;">
    <div v-if="forgetPassword" class="ds-container h-100" style=" justify-content: center;width: 100%;">
      <div class="ds-header">重置密码</div>
      <div class="reSet-form">
        <el-form ref="resetFormRef" :model="reSetForm" :rules="rules">
          <el-form-item prop="userName" label="">
            <el-input v-model="reSetForm.userName" placeholder="请输入你的电话号码/电子邮箱" clearable />
          </el-form-item>
          <el-form-item prop="name" label="">
            <el-input v-model="reSetForm.name" placeholder="请输入你的姓名" clearable />
          </el-form-item>
          <el-form-item prop="idCard" label="">
            <el-input v-model="reSetForm.idCard" placeholder="请输入你的身份证号" clearable />
          </el-form-item>
          <el-form-item prop="password" label="">
            <el-input v-model="reSetForm.password" placeholder="请输入你的登录密码" clearable show-password />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="">
            <el-input v-model="reSetForm.confirmPassword" placeholder="请再次输入你的登录密码" clearable show-password />
          </el-form-item>
        </el-form>
      </div>
      <div class="w-100 footer" style="margin-top: 10px;">
        <el-button class="submit-btn" type="primary" :loading="submitLoading"
          @click="handleReset('submit')">重置密码</el-button>
        <el-button class="submit-btn back" type="" :loading="submitLoading" @click="handleReset('back')">返回</el-button>
      </div>
    </div>
    <div v-else class="ds-container h-100" style="width: 100%;justify-content: center;">
      <div class="ds-header">{{ title }}</div>
      <div :class="[isLogin ? 'ds-main' : 'reSet-form']">
        <el-form ref="loginFormRef" :model="formData" :rules="rules">
          <el-form-item prop="userName" label="">
            <el-input v-model="formData.userName" placeholder="请输入你的电话号码/电子邮箱" clearable />
          </el-form-item>
          <!--  -->
          <el-form-item v-if="!isLogin" prop="name" label="">
            <el-input v-model="formData.name" placeholder="请输入你的姓名" clearable />
          </el-form-item>
          <el-form-item v-if="!isLogin" prop="idCard" label="">
            <el-input v-model="formData.idCard" placeholder="请输入你的身份证号" clearable />
          </el-form-item>
          <el-form-item prop="password" label="">
            <el-input v-model="formData.password" placeholder="请输入你的登录密码" clearable show-password />
          </el-form-item>
          <div v-if="isLogin" style="text-align: right;font-size: 16px;color: #A40000;cursor: pointer;"
            @click="forgetPassword = true">忘记密码？</div>
          <el-form-item v-if="!isLogin" prop="confirmPassword" label="">
            <el-input v-model="formData.confirmPassword" placeholder="请再次输入你的登录密码" clearable show-password />
          </el-form-item>
          <div v-if="!isLogin"
            style="font-size: 14px;color: #A40000;text-align: right;line-height: 16px;margin-bottom: 10px;">
            密码8-16位（含字母、数字、特殊字符）</div>
        </el-form>
      </div>
      <div class="footer w-100" v-if="isLogin" style="margin-top: 30px;">
        <el-button class="submit-btn" type="primary" :loading="submitLoading" @click="onSubmit">
          登录
        </el-button>
      </div>
      <div class="footer w-100" v-else>
        <el-button class="submit-btn" type="primary" :loading="submitLoading" @click="onSubmit">
          注册
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      formData: {
        userName: "",
        password: "",
        confirmPassword: "",
        name: "",
        idCard: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message: "请输入电话号码/电子邮箱",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          {
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
      },
      submitLoading: false,
      // 忘记密码 重置密码
      forgetPassword: false,
      reSetForm: {
        userName: "",
        name: "",
        idCard: "",
        password: "",
        confirmPassword: "",
      }
    };
  },
  computed: {
    isLogin() {
      return this.type === "login";
    },
    title() {
      return this.isLogin ? "用户登录" : "用户注册";
    },
  },
  methods: {
    ...mapActions(["Login", "RegisterLogin", "fetchExamDataList"]),
    async onSubmit() {
      try {
        const api = this.isLogin ? this.Login : this.RegisterLogin;
        if (this.isLogin) {
          await this.fetchExamDataList();
        }
        this.$refs.loginFormRef.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true
            api({ ...this.formData }).then(async () => {
              // 登录后直接进入报名列表页（不经过 dashboard，避免先闪出 5 个菜单）
              this.$router.push({ name: "exam-examlist" });
              if (!this.isLogin) {
                this.formData = {};
                this.$message.success("注册成功！请登录");
                this.$emit("update:type", "login");
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (error) {
        console.log("error:", error);
      } finally {
        this.submitLoading = false
      }
    },
    handleReset(type) {
      if (type === 'submit') {
        this.$refs.resetFormRef.validate(async (valid) => {
          if (valid) {
            if (this.reSetForm.password !== this.reSetForm.confirmPassword) {
              this.$message.error("两次输入的密码不一致");
              return;
            }
            this.submitLoading = true;
            try {
              await this.$store.dispatch("ResetPassword", {
                userName: this.reSetForm.userName,
                name: this.reSetForm.name,
                idCard: this.reSetForm.idCard,
                password: this.reSetForm.password,
                confirmPassword: this.reSetForm.confirmPassword,
              });
              this.$message.success("密码重置成功！请使用新密码登录");
              this.forgetPassword = false;
              this.reSetForm = {};
              this.$refs.resetFormRef.resetFields();
            } catch (error) {
              console.error("重置密码失败:", error);
              // this.$message.error("重置密码失败，请检查输入信息");
            } finally {
              this.submitLoading = false;
            }
          } else {
            console.log("验证失败");
            return false;
          }
        });
      } else {
        this.forgetPassword = false;
        this.reSetForm = {};
        if (this.$refs.resetFormRef) {
          this.$refs.resetFormRef.resetFields();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
button {
  padding: 0;
  margin: 0;
}

.ds-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.ds-header {
  font-weight: bold;
  font-size: clamp(28px, 4vw, 44px);
  color: #A40000;
}

.ds-main {
  margin-top: clamp(25px, 3vw, 40px);
  width: 100%;

  :deep(.el-form-item) {
    margin-bottom: clamp(18px, 2vw, 26px);
    width: 100% !important;
  }

  :deep(.el-input__inner) {
    box-sizing: border-box;
    width: 100% !important;
    height: clamp(48px, 5vw, 68px);
    background: rgba(204, 204, 204, 0.18);
    border-radius: 516px;
    text-align: center;
    font-size: clamp(16px, 2vw, 24px);
  }
}

.reSet-form {
  margin-top: clamp(15px, 2vw, 20px);
  width: 100% !important;

  :deep(.el-form-item) {
    margin-bottom: clamp(14px, 1.5vw, 18px);
    width: 100% !important;
  }

  :deep(.el-input__inner) {
    box-sizing: border-box;
    width: 100% !important;
    height: clamp(40px, 4vw, 46px);
    background: rgba(204, 204, 204, 0.18);
    border-radius: 516px;
    text-align: center;
    font-size: clamp(14px, 1.8vw, 20px);
  }
}

.footer {
  display: flex;
  justify-content: center;
  gap: clamp(10px, 2vw, 20px);

  .submit-btn {
    box-sizing: border-box;
    width: clamp(120px, 50%, 200px);
    height: clamp(40px, 4vw, 56px);
    border: none !important;
    background: linear-gradient(0deg, #A40000, #CC3B16);
    box-shadow: 0px 4px 13px 0px rgba(229, 100, 136, 0.52);
    border-radius: 196px;
    font-weight: 400;
    font-size: clamp(16px, 1.8vw, 24px);
    color: #ffffff;
  }

  .back {
    background: #ffffff;
    color: #333;
    box-shadow: 0px 3px 10px 0px rgba(213, 214, 215, 0.52);
  }
}

@media screen and (max-width: 850px) {
  .ds-header {
    font-size: clamp(24px, 5vw, 36px);
  }

  .ds-main :deep(.el-input__inner),
  .reSet-form :deep(.el-input__inner) {
    font-size: clamp(14px, 2vw, 18px);
  }

  .footer .submit-btn {
    width: clamp(100px, 40%, 160px);
    font-size: clamp(14px, 2vw, 20px);
  }
}

@media screen and (max-width: 640px) {
  .ds-header {
    font-size: clamp(20px, 6vw, 30px);
  }

  .ds-main :deep(.el-input__inner),
  .reSet-form :deep(.el-input__inner) {
    height: clamp(36px, 6vw, 48px);
    font-size: clamp(13px, 2.2vw, 16px);
  }

  .footer {
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .submit-btn {
      width: 80%;
      height: clamp(36px, 5vw, 48px);
      font-size: clamp(14px, 2.5vw, 18px);
    }
  }
}

@media screen and (min-height: 1080px) {
  .ds-header {
    font-size: clamp(36px, 4vw, 52px);
  }

  .ds-main {
    margin-top: clamp(35px, 4vw, 50px);

    :deep(.el-input__inner) {
      height: clamp(60px, 5vw, 80px);
      font-size: clamp(20px, 2.5vw, 28px);
    }
  }

  .footer .submit-btn {
    height: clamp(50px, 4vw, 68px);
    font-size: clamp(20px, 2vw, 28px);
  }
}

@media screen and (max-height: 600px) {
  .ds-header {
    font-size: clamp(22px, 4vw, 32px);
  }

  .ds-main {
    margin-top: clamp(15px, 2vw, 25px);

    :deep(.el-form-item) {
      margin-bottom: clamp(12px, 1.5vw, 18px);
    }

    :deep(.el-input__inner) {
      height: clamp(36px, 4vw, 48px);
      font-size: clamp(14px, 1.8vw, 18px);
    }
  }

  .reSet-form :deep(.el-input__inner) {
    height: clamp(32px, 3.5vw, 40px);
    font-size: clamp(12px, 1.5vw, 16px);
  }

  .footer .submit-btn {
    height: clamp(34px, 4vw, 46px);
    font-size: clamp(14px, 1.8vw, 18px);
  }
}
</style>
